import React from "react";
export default function Vehicle_Data_Table_Charging(props) {
  let { data } = props;
  return (
    <>
      {data.length === 0
        ? 
          <>
            <tr>
              <td colSpan={7}>No data found</td>
            </tr>
          </>
        : data.map((x, index) => {
          let date = new Date(x.First_data_received);
          let event_date = new Date(x.Last_data_received);
          let Fdate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
          let Ldate = event_date.getDate() + '/' + (event_date.getMonth() + 1) + '/' + event_date.getFullYear()
            return (
              <tr key={index}>
                <td scope="row">{index+1}</td>
                <td scope="row">{x.VIN}</td>
                <td scope="row">{x.CITY}</td>
                <td scope="row">{Fdate}</td>
                <td scope="row">{Ldate}</td>
                <td scope="row">{x.Last_SOC_received}</td>
                <td scope="row">{x.Days_since_unavailability_Days}</td>
              </tr>
            );
          })}
    </>
  );
}
